export const AUTH = {
  EMAIL_ERROR_MESSAGE: "Looks like email is wrong.",
  PASSWORD_ERROR_MESSAGE: "Password should not be empty.",
};
